import classes from "../CreateCustomer/CreateCustomer.module.css";
import Button from "../../../Components/Button";
import InputWithSearch from "../../../Components/InputWithSearch";
import { fetchSalesPersonByUserId } from "../../../Services/Dashboard/tableGridService";
import { useMemo, useState } from "react";

const EditCustomer = ({ editCustomerData, editCustomerFn, getSelectedChFn, isLoading }) => {
  const [newChState, setNewChState] = useState(null);
  const [newChIdInput, setNewChIdInput] = useState('');

  const onSearchFn = async (event) => {
    if (!event) {
      return;
    }
    setNewChIdInput(event);
    try {
      const res = await fetchSalesPersonByUserId(event);
      const [chData] = res?.data?.data || [];
      getSelectedChFn({...chData, chId: event});
      setNewChState({...chData, chId: event});
    } catch (e) {
      throw e;
    }
  };

  const inputWithSearchChange = () => {
    setNewChState(null);
  };

  const salesPersonUserIds = useMemo(() => {
    if (!editCustomerData) {
      return '';
    }
    return editCustomerData?.map(ecd => ecd?.salesPersonUserId)?.join();
  }, [editCustomerData])

  return (
    <div className={classes["form-wrapper"]}>
      <div className={classes["form-group"]}>
        <label>Existing CH ID</label>
        <input type="text" value={salesPersonUserIds} readOnly />
      </div>
      <div className={classes["form-group"]}>
        <label>New CH ID</label>
        <InputWithSearch
          onChange={inputWithSearchChange}
          onSearchFn={onSearchFn}
        />
      </div>
      <div className={classes["form-group"]}>
        <label>New CH Name</label>
        <input type="text" value={newChState?.empName || ''} readOnly />
      </div>
      <Button
        disabled={!newChState || isLoading}
        onClick={editCustomerFn}
      >
        {isLoading ? 'Loading' : 'Done'}
      </Button>
    </div>
  );
};

export default EditCustomer;
